import { defineStore } from 'pinia'
import type { ScrollbarInst } from 'naive-ui'
import { getHistoryListApi } from '../api'
import type { IHistoryRes } from '../types'
import { EMessageType, EUserType } from '../constant'
import { Message } from '../models/message'
import { asstStore } from './asst-store'

export const historyListStore = defineStore('historyListStore', () => {
  const historyMessageList = ref<any[]>([])
  const asst = asstStore()

  const messageScrollRef = ref<ScrollbarInst>()
  const listDom = ref<HTMLDivElement>()

  const page = ref(1)
  const pageSize = ref(10)
  const isToFirst = ref(false)
  const loadingHistoryList = ref(false)

  async function getHistoryList(isBottom = true) {
    if (isToFirst.value) {
      return
    }

    loadingHistoryList.value = true
    try {
      const res = await getHistoryListApi({
        bean: {
          businessType: asst.chatConfig.currentType,
          enterpriseId: String(asst.currentWorkspace.workspaceId),
        },
        page: page.value,
        pageSize: pageSize.value,
      })

      console.log('🚀 ~ getHistoryList ~ res:', messageScrollRef.value)

      _handleHistoryRes(res?.records || [])

      if (isBottom) {
        toBottom()
      }

      if (res?.records.length < pageSize.value) {
        isToFirst.value = true
      }

      page.value += 1

      loadingHistoryList.value = false
    } catch (error) {
      loadingHistoryList.value = false
    }
  }

  function toBottom() {
    if (messageScrollRef.value) {
      nextTick(() => {
        messageScrollRef.value?.scrollTo({
          top: 300000,
        })
      })
    }
  }

  function _handleHistoryRes(list: IHistoryRes['records']) {
    const hList: Message[] = []
    list.forEach((m) => {
      let message: Message | null = null

      if (m.role === EUserType.USER) {
        message = new Message(EMessageType.QUESTION, {
          createTime: m.createTime,
          content: m.reply,
          requestId: m.requestId,
        })
      } else {
        switch (m.type) {
          case 0:
            message = new Message(EMessageType.REPLY, {
              createTime: m.createTime,
              content: m.reply,
              reasoningContent: m.reasoningContent,
              model: m.reasoningContent ? 8 : null, // reasoningContent有值，使用了8：r1模型
              requestId: m.requestId,
              knowledgeFlag: m.knowledgeFlag, // 0: 不限知识库 1: 使用知识库
            })
            message.updateReasoningTime(m?.reasoningDuration || 0)
            m.docList?.length && message.updateDocList(m.docList)
            m.docReplyType && message.setCocReplyType(m.docReplyType)
            break
          case 1:
            try {
              const reply = JSON.parse(m.reply)
              message = new Message(EMessageType.REPLY, {
                content: '已为你找到如下文件/资料：',
                createTime: m.createTime,
                requestId: m.requestId,
                fileList: reply,
              })
            } catch (e) {
              console.error('类型1', e)
            }
            break
          case 2:
            try {
              const reply = JSON.parse(m.reply)
              const { mechanism, effect } = JSON.parse(m.obiter)
              message = new Message(EMessageType.MATERIAL, {
                content: `通过“${mechanism}”达到${effect}功效的原料主要有：`,
                requestId: m.requestId,
                createTime: m.createTime,
                materials: reply,
              })
            } catch (e) {
              console.log('类型2 ', e)
            }
            break
          case 3:
            if (m.ranges.length > 0) {
              message = new Message(EMessageType.RANGE, {
                requestId: m.requestId,
                createTime: m.createTime,
                rangeList: m.ranges,
              })
            }
            break
          case 4:
            try {
              console.log(m)
              const errorMessage = JSON.parse(m.reply)
              message = new Message(EMessageType.REPLY, {
                createTime: errorMessage.createTime,
                requestId: errorMessage.requestId,
                content: errorMessage.text,
              })
              errorMessage.staffImg && message.updateImg([errorMessage.staffImg])
            } catch (e) {
              console.error('类型1', e)
            }
            break
          default:
            break
        }
      }

      if (message) {
        hList.push(message)
      }
    })

    historyMessageList.value.unshift(...hList)
  }

  function reset() {
    historyMessageList.value = []
    isToFirst.value = false
    page.value = 1
  }

  return {
    getHistoryList,
    reset,
    toBottom,
    historyMessageList,
    messageScrollRef,
    listDom,
    page,
    pageSize,
    isToFirst,
  }
})
